// import {useNavigate as useReactNavigate } from 'react-router-dom';
export const handleLogin = (navigate:any) => {
  navigate('/inicio');
};

export const generarGUID =()=> {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
};